import { CaptainOptionValue } from 'src/common/types/CaptainOptions';
import { PARAM_KEYS } from 'src/book-now-review/constants';
import { PARAM_INQUIRY_ID } from 'src/inquiry/constants';
import { EXTERNAL_PATHS, PATHS } from '../../common/constants';
import { InstabookAvailability } from '../../common/types/api/v4/instabook';

export const getListingPageUrl = (boatId: string, recentSearchId?: string): string => {
  const searchParams = new URLSearchParams();
  if (recentSearchId) {
    searchParams.append('pk', recentSearchId);
  }

  return `${PATHS.LISTING}${boatId}/?${searchParams.toString()}`;
};
export const getListingPagePreviewUrl = (listingId: string): string => `${PATHS.ADMIN_LISTING_EDITOR}${listingId}${PATHS.ADMIN_LISTING_PREVIEW}`;

export const getInquiryUrl = (
  listingId: string,
  startDate: string,
  duration: string,
  capacity: number,
  captainOption: CaptainOptionValue,
  endDate?: string,
): string => {
  const searchParams = new URLSearchParams({
    start_date: startDate,
    ...(endDate && { end_date: endDate }),
    duration,
    capacity: `${capacity}`,
    captain_option: `${captainOption}`,
  });

  return `${PATHS.LISTING}${listingId}${PATHS.INQUIRY}?${searchParams.toString()}`;
};

export const getInquirySuccessUrl = (
  listingId: string,
  inquiryId: string,
): string => {
  const searchParams = new URLSearchParams({ [PARAM_INQUIRY_ID]: inquiryId });
  return `${PATHS.LISTING}${listingId}${PATHS.INQUIRY_SUCCESS}?${searchParams.toString()}`;
};

export const getInquiryUrlOld = (
  boatId: string,
  returnUrl: string,
  selectedDate?: string,
  currency?: string,
): string => {
  const searchParams = new URLSearchParams({ return: returnUrl });
  if (selectedDate) searchParams.append('preferredDate', selectedDate);
  if (currency) searchParams.append('currency', currency);

  const url = `${EXTERNAL_PATHS.INQUIRY}${boatId}/`;
  return `${url}?${searchParams.toString()}`;
};

export const getBookNowUrl = (
  listingId: string,
  date: string,
  duration: string,
  capacity: number,
  captainOption: CaptainOptionValue,
): string => {
  const searchParams = new URLSearchParams({
    [PARAM_KEYS.DATE]: date,
    [PARAM_KEYS.DURATION]: duration,
    [PARAM_KEYS.CAPACITY]: `${capacity}`,
    [PARAM_KEYS.CAPTAIN_OPTION]: `${captainOption}`,
  });

  return `/trips/${listingId}/book-now/?${searchParams.toString()}`;
};

export const getInstabookUrl = (
  boatId: string,
  returnUrl: string,
  selectedDate?: string,
  currency?: string,
  startingDate?: string,
  endingDate?: string,
): string => {
  const searchParams = new URLSearchParams({ return: returnUrl });
  if (selectedDate) searchParams.append('selectedDate', selectedDate);
  if (startingDate) searchParams.append('startingDate', startingDate);
  if (endingDate) searchParams.append('endingDate', endingDate);
  if (currency) searchParams.append('currency', currency);

  const url = `${EXTERNAL_PATHS.INSTABOOK_BOOKING}${boatId}/trips/`;
  return `${url}?${searchParams.toString()}`;
};

type Trip = Pick<InstabookAvailability, 'id' | 'date'>;

export const getInstabookTripUrl = (
  trip: Trip,
  boatId: string,
  returnUrl: string,
  currency?: string,
): string => {
  const searchParams = new URLSearchParams({
    date: trip.date,
    return: returnUrl,
  });

  if (currency) searchParams.append('currency', currency);

  return `${EXTERNAL_PATHS.INSTABOOK}${boatId}/details/${trip.id}/?${searchParams.toString()}`;
};
